
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disclaimer-source-of-recommendations",
      function () {
        return require("private-next-pages/disclaimer-source-of-recommendations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disclaimer-source-of-recommendations"])
      });
    }
  